import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import { Box, Stack, Button, Typography } from '@mui/material';

import AddCircleIcon from '@mui/icons-material/AddCircle';

import TicketShoppingCartSummary from './TicketShoppingCartSummary';
import useShoppingCartContext from '../../context/ShoppingCart/use-shopping-cart-context';
import { isOneWayTrip } from '../../domain/travels';
import { ParkingShoppingCartSummary } from './parking-shopping-cart-summary';
import { ShuttleShoppingCartSummary } from './shuttle-shopping-cart-summary';
import { WheelsShoppingCartSummary } from './wheels-shopping-cart-summary';
import { ServiceType } from '../../domain/common/service';
import { TravelClubShoppingCartSummary } from '../../features/travel-club';
import { BlackCarsShoppingCartSummary } from './black-cars-shopping-cart-summary';
import { InsuranceShoppingCartSummary } from '../../features/insurance';

export default function ShoppingCartTicketsSummary({ onAddTicket = () => { } }) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { cart, removeServiceFromCart } = useShoppingCartContext();

  const buildTicketType = (item) => {
    const qty = item.item.tixProd.NuProdQuant;
    const type = language === `es` ? item.item.tixProd.DsPublicEs : item.item.tixProd.DsPublic;

    return `x${qty} ${type}`;
  };

  return (
    <Box padding="0px 24px 16px 24px" sx={{ height: '100%' }}>
      <Stack
        width="100%"
        padding="8px 0px"
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        borderBottom="1px solid rgba(0, 0, 0, 0.12)"
      >
        <Typography color="secondary" variant="body1" fontWeight={700}>
          {t('shopping_cart.tickets_summary.title')}
        </Typography>
        <Button sx={{ color: '#EF60A3' }} variant="text" onClick={onAddTicket} startIcon={<AddCircleIcon />}>
          {t('shopping_cart.tickets_summary.add_more')}
        </Button>
      </Stack>
      <Stack direction="column" gap="3px">
        {cart.items.map((item) => {
          if (item.type === 'SingleTicket') {
            const travelTypei18n = isOneWayTrip(item.item.tripType) ? 'trip_types.one_way' : 'trip_types.round_trip';
            let ticketType = buildTicketType(item);
            return (
              <TicketShoppingCartSummary
                key={item.item.id}
                onRemove={() => { removeServiceFromCart(item.item) }}
                onEdit={() => { onAddTicket(item.item.id) }}
                origin={item.item.origin}
                destination={item.item.destination}
                departureDate={new Date(item.item.departureDate).toLocaleDateString()}
                returnDate={item.item.returnDate ? new Date(item.item.returnDate).toLocaleDateString() : item.item.returnDate?.toLocaleDateString()}
                travelType={t(travelTypei18n)}
                total={item.item.total}
                ticketType={ticketType}
                quantity={item.quantity}
                DiscountAmount={item.item.DiscountAmount}
                DiscountCaption={item.item.DiscountCaption}
                NonDiscountAmount={item.item.NonDiscountAmount}
              />
            );
          }

          if (item.type === ServiceType.Parking) return <ParkingShoppingCartSummary parking={item.item} onRemove={() => { removeServiceFromCart(item.item) }} onEdit={() => { onAddTicket(item.item.id) }} />;

          if (item.type === ServiceType.Shuttle) return <ShuttleShoppingCartSummary shuttle={item.item} onRemove={() => { removeServiceFromCart(item.item) }} onEdit={() => { onAddTicket(item.item.id) }} />;

          if (item.type === ServiceType.Wheels) return <WheelsShoppingCartSummary wheels={item.item} onRemove={() => { removeServiceFromCart(item.item) }} onEdit={() => { onAddTicket(item.item.id) }} />;

          if (item.type === ServiceType.TravelClub) return <TravelClubShoppingCartSummary travelClub={item.item} onRemove={() => { removeServiceFromCart(item.item) }} />;
          
          if (item.type === ServiceType.BlackCars) return <BlackCarsShoppingCartSummary blackCars={item.item} onRemove={() => { removeServiceFromCart(item.item) }} />;
          
          if (item.type === ServiceType.Insurance) return <InsuranceShoppingCartSummary insurance={item.item} onRemove={() => { removeServiceFromCart(item.item) }} />;

          return null;
        })}
      </Stack>
    </Box>
  );
}
